module.exports = __webpack_public_path__ + "static/media/VHAN_badge.d92ff82f.png";